import React from "react";
import type { SubjectAssignment } from "../types/subject";
import { groupMembers } from "../utils/subjects";
interface SubjectListProps {
  assignments: SubjectAssignment[];
  tone?: "light" | "dark";
}
export function SubjectList({
  assignments,
  tone = "light"
}: SubjectListProps) {
  const dark = tone === "dark";
  return <ol className={`divide-y border-y ${dark ? "divide-white/10 border-white/10" : "divide-line border-line"}`} aria-live="polite" data-id="element-701" data-mp="1etq006zrlmum">
      {assignments.map(a => <li key={a.team} className="flex gap-4 py-3" data-id="element-702" data-mp="27hvnh1i7dpy5">
          <span className="w-16 shrink-0 pt-0.5 text-sm font-semibold" data-id="element-703" data-mp="22hr2oza9i924">Group {a.team}</span>
          <div className="min-w-0 flex-1" data-id="element-704" data-mp="22jkd8pnzxdfe">
            <p className={`text-[15px] font-semibold ${dark ? "text-bryellow" : "text-ink"}`} data-id="element-705" data-mp="1xjfvyxf9keo4">{a.subject}</p>
            <div className="mt-1 flex flex-wrap gap-x-4 gap-y-1" data-id="element-706" data-mp="r3lzi8hvi37u">
              {groupMembers(a.team).map(m => <span key={m.name} className={`inline-flex items-center gap-1.5 text-sm ${dark ? "text-white/80" : "text-muted"}`} data-id="element-707" data-mp="m1wminb3bfh4">
                  <span className={`h-2 w-2 rounded-full ${m.school === "link" ? "bg-brgreen" : "bg-saffron"}`} aria-hidden="true" data-id="element-708" data-mp="2p4f4udzjmev" />
                  {m.name}
                </span>)}
            </div>
          </div>
        </li>)}
    </ol>;
}